import React, { useEffect, useState } from 'react';
import { api } from '../../../lib/api';
import { Calculator } from 'lucide-react';

/* ---------------- Tax estimate panel ---------------- */

function TaxPanel({ f }) {
  const [result, setResult] = useState(null);
  const gross = parseFloat(f.monthly_salary) || (parseFloat(f.hourly_wage) || 0) * (parseFloat(f.weekly_hours) || 40) * 4.33;

  useEffect(() => {
    if (!gross || gross <= 0) { setResult(null); return; }
    const t = setTimeout(() => {
      api.get('/hr/tax-estimate', { params: { gross_monthly: gross, country: f.tax_country || 'PL', hire_type: f.hire_type } })
        .then(r => setResult(r.data)).catch(() => setResult(null));
    }, 400);
    return () => clearTimeout(t);
  }, [gross, f.tax_country, f.hire_type]);

  if (!result) return gross > 0 ? <div className="text-xs text-fg-muted mt-2">Calculating tax estimate…</div> : null;
  return (
    <div className="mt-3 surface border border-soft rounded-lg p-3 text-xs" data-testid="hr-tax-panel">
      <div className="flex items-center gap-1.5 font-semibold mb-2"><Calculator className="w-3.5 h-3.5 text-brand"/> Tax & payroll estimate — {result.country} · {result.scheme}</div>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <div className="text-fg-muted uppercase tracking-wide text-[10px] mb-1">Employee take-home</div>
          {result.employee_lines.map((l, i) => (
            <div key={i} className="flex justify-between py-0.5"><span>{l.label}</span><span className={l.amount < 0 ? 'text-[#B83A3A]' : ''}>{l.amount.toFixed(2)}</span></div>
          ))}
          <div className="flex justify-between font-bold border-t border-soft mt-1 pt-1"><span>Net / month</span><span data-testid="hr-tax-net">{result.net_monthly.toFixed(2)} {f.currency}</span></div>
        </div>
        <div>
          <div className="text-fg-muted uppercase tracking-wide text-[10px] mb-1">Total employer cost</div>
          {result.employer_lines.map((l, i) => (
            <div key={i} className="flex justify-between py-0.5"><span>{l.label}</span><span>{l.amount.toFixed(2)}</span></div>
          ))}
          <div className="flex justify-between font-bold border-t border-soft mt-1 pt-1"><span>Employer total / month</span><span>{result.employer_total_cost.toFixed(2)} {f.currency}</span></div>
        </div>
      </div>
      <div className="text-[10px] text-fg-muted mt-2">{result.disclaimer}</div>
    </div>
  );
}

export { TaxPanel };
